'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

var _palette = require('../foundational-styles/palette');

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Appearances = {};

Appearances.default = _themer.Themer.createRowAppearance({
  base: {},

  hover: {
    backgroundColor: _scales2.default.neutral.N1A
  },

  focus: {
    backgroundColor: _scales2.default.primary.P1A
  },

  active: {
    backgroundColor: _scales2.default.primary.P2A
  },

  current: {}
});

Appearances.danger = _themer.Themer.createRowAppearance({
  base: {
    backgroundColor: _palette2.default.red.lightest
  },

  hover: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.red.lightest).darken(1).toString()
  },

  focus: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.red.lightest).darken(1.5).toString()
  },

  active: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.red.lightest).darken(2.2).toString()
  },

  current: {}
});

Appearances.warning = _themer.Themer.createRowAppearance({
  base: {
    backgroundColor: _palette2.default.orange.lightest
  },

  hover: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.orange.lightest).darken(1).toString()
  },

  focus: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.orange.lightest).darken(1.5).toString()
  },

  active: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.orange.lightest).darken(2.5).toString()
  },

  current: {}
});

Appearances.success = _themer.Themer.createRowAppearance({
  base: {
    backgroundColor: _palette2.default.green.lightest
  },

  hover: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.green.lightest).darken(1).toString()
  },

  focus: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.green.lightest).darken(2).toString()
  },

  active: {
    backgroundColor: (0, _tinycolor2.default)(_palette2.default.green.lightest).darken(3).toString()
  },

  current: {}
});

/**
 * Get the appearance of a `Row`.
 * @param {string} appearance — only one default appearance.
 * @param {string} intent - none, info, success, warning, danger.
 * @return {string} the appearance object.
 */
var getRowAppearance = function getRowAppearance(appearance, intent) {
  switch (intent) {
    case 'danger':
      return Appearances.danger;
    case 'warning':
      return Appearances.warning;
    case 'success':
      return Appearances.success;
    case 'none':
    default:
      return Appearances.default;
  }
};

/**
 * Get the className of a `Row`.
 * @param {string} appearance
 * @return {string} the appearance class name.
 */
exports.default = (0, _memoizeClassName2.default)(getRowAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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